import {fsa, fsaPayloadByKeys, gateAction} from './helpers'
import * as pdp from '../store/productDetailPage'
import {advancedPdpImageClicked} from '../track/track'

// -- Actions

export const SELECT_TRANSACTION_TYPE = 'pdp/select transaction type'
export const selectTransactionType = fsaPayloadByKeys(SELECT_TRANSACTION_TYPE, ['transactionType'])

export const OPEN_PARTY_AVAILABLE_MODAL = 'open modal when product is not party available'
export const openPartyAvailableModal = (cb) => ({
  type: OPEN_PARTY_AVAILABLE_MODAL,
  callback: cb,
})

export const OPEN_SOLD_OUT_MODAL = 'open modal when product is sold out for users event date'
export const openSoldOutModal = () => ({type: OPEN_SOLD_OUT_MODAL})

export const OPEN_ZOOM_MODAL = 'open up product image zoom modal'
export const openZoomModal = () => ({type: OPEN_ZOOM_MODAL})

export const ZOOM_IN = 'zoom in on product image'
export const zoomIn = () => ({type: ZOOM_IN})

export const ZOOM_OUT = 'zoom out on product image'
export const zoomOut = () => ({type: ZOOM_OUT})

export const DISPLAY_NEXT_IMAGE = 'display next image'
export const displayNextImage = (index) => ({
  type: DISPLAY_NEXT_IMAGE,
  index,
})

export const DISPLAY_PREVIOUS_IMAGE = 'display previous image'
export const displayPreviousImage = (index) => ({
  type: DISPLAY_PREVIOUS_IMAGE,
  index,
})

export const SELECT_ZOOM_THUMBNAIL = 'select zoom image thumbnail'
export const selectZoomThumbnail = (index) => ({
  type: SELECT_ZOOM_THUMBNAIL,
  index,
})

// -- Thunks

export const CLOSE_PARTY_AVAILABLE_MODAL = 'close party available warning modal'
export const _closePartyAvailableModal = fsa(CLOSE_PARTY_AVAILABLE_MODAL)
export const closePartyAvailableModal = gateAction(
  _closePartyAvailableModal,
  pdp.partyAvailableModalIsOpen,
)

export const CLOSE_SOLD_OUT_MODAL = 'close sold out warning modal'
export const _closeSoldOutModal = fsa(CLOSE_SOLD_OUT_MODAL)
export const closeSoldOutModal = gateAction(_closeSoldOutModal, pdp.soldOutModalIsOpen)

export const CLOSE_ZOOM_MODAL = 'close product image zoom modal'
export const _closeZoomModal = fsa(CLOSE_ZOOM_MODAL)
export const closeZoomModal = gateAction(_closeZoomModal, pdp.zoomModalIsOpen)

export const imageCarouselControl = (direction) => (dispatch, getState) => {
  let index
  const state = getState()
  if (direction === 'next') {
    index = (pdp.currentZoomImageIndex(state) + 1) % pdp.productAndModelImages(state).length
    dispatch(displayNextImage(index))
    advancedPdpImageClicked(index, pdp.productName(state), pdp.productId(state), 'carousel')
  } else {
    index =
      (pdp.currentZoomImageIndex(state) + pdp.productAndModelImages(state).length - 1) %
      pdp.productAndModelImages(state).length
    dispatch(displayPreviousImage(index))
    advancedPdpImageClicked(index, pdp.productName(state), pdp.productId(state), 'carousel')
  }
}
